const buildBestBacktestingSoftware = require('./bestBacktestingSoftware');
const buildBacktestingMetricsExplained = require('./backtestingMetricsExplained');
const buildAvoidOverfittingTradingStrategies = require('./avoidOverfittingTradingStrategies');
const buildWalkForwardTestingTradingStrategies = require('./walkForwardTestingTradingStrategies');
const buildLookAheadBiasAndDataLeakage = require('./lookAheadBiasAndDataLeakage');
const buildModelingSlippageFeesAndMarketImpact = require('./modelingSlippageFeesAndMarketImpact');
const buildAlgorithmicTradingRiskManagement = require('./algorithmicTradingRiskManagement');
const buildConnectChatgptToYourBroker = require('./connectChatgptToYourBroker');
const buildConnectClaudeToYourBroker = require('./connectClaudeToYourBroker');
const buildConnectCodexToYourBroker = require('./connectCodexToYourBroker');

const GUIDE_BUILDERS = [
  buildBestBacktestingSoftware,
  buildBacktestingMetricsExplained,
  buildAvoidOverfittingTradingStrategies,
  buildWalkForwardTestingTradingStrategies,
  buildLookAheadBiasAndDataLeakage,
  buildModelingSlippageFeesAndMarketImpact,
  buildAlgorithmicTradingRiskManagement,
  buildConnectChatgptToYourBroker,
  buildConnectClaudeToYourBroker,
  buildConnectCodexToYourBroker,
];

function buildAdditionalSeoGuides({ agentProofPoints }) {
  return GUIDE_BUILDERS.map((buildGuide) => buildGuide({ agentProofPoints }));
}

module.exports = {
  buildAdditionalSeoGuides,
};
